module.exports = __webpack_public_path__ + "static/img/4.a8ef781.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/articleProject/images/qlxj/4.png
// module id = QHzf
// module chunks = 7